// extracted by mini-css-extract-plugin
export const visibleSmallUp = "AssetsPage__visibleSmallUp__8sTfQ";